import { useMemo } from 'react'
import {
  selectScheduledThreadIds,
  selectScheduledWorkflows,
} from '@/features/chat/scheduledThreadIds'
import { splitNavThreadGroups } from '@/features/chat/splitNavThreadGroups'
import { useWorkflows } from '@/features/chat/workflows/useWorkflows'

/** Pinned / Chats thread groups plus the schedules the Scheduled section lists. */
export function useHomeNavThreadGroups(threads = [], pinnedThreadIds = []) {
  const workflowsQuery = useWorkflows()
  const workflowsData = workflowsQuery.data
  const workflows = useMemo(() => workflowsData ?? [], [workflowsData])

  const scheduledThreadIds = useMemo(() => selectScheduledThreadIds(workflows), [workflows])
  const scheduledWorkflows = useMemo(() => selectScheduledWorkflows(workflows), [workflows])
  const groups = useMemo(
    () => splitNavThreadGroups(threads, pinnedThreadIds),
    [threads, pinnedThreadIds],
  )

  return { ...groups, scheduledWorkflows, scheduledThreadIds }
}
